import { Divider } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { GoBackButton } from "../../../components/GoBackButton";
import { media, theme, size } from "../../../helpers/theme";
import SessionService from "../../../services/session-service";
import { url } from "../../../utils/url";
import { AdditionalRemarks } from "./components/additional-remarks";
import {
  CollapseFaqArrayProps,
  CollapseInfo,
} from "./components/collapse-info";
import { CustomerData } from "./components/customer-data";

import { HowItWorks } from "./components/how-it-works";
import { PropertySummaryItem, Quantum } from "./components/quantum";
import { SubmitAnInquiryButton } from "./components/submit-an-inquiry-button";
import { PropertyItem, Summary } from "./components/summary";
import { TypesOfOffers } from "./components/types-of-offers";

const title = `Podsumowanie`;
const titleInfo1 = "Jak to działa?";
const titleInfo2 = "Rodzaje oferty";

type orderFormData = {
  opis_uslugi: string;
  termin_rozpoczecia: Date;
  termin_zakonczenia: Date;
  kraj: string;
  wojewodztwo: string;
  kod_pocztowy: string;
  miasto: string;
  szerokosc_geograficzna: string;
  dlugosc_geograficzna: string;
  miejsce: string;
  rodzaj_skladowania: string;
  warunek_temperaturowy: string;
  rodzaj_towaru: string;
  opis_towaru: string;
  specjalny_sprzet: string;
  dodatkowe_uwagi: string;
  uslugi_zamowione: {
    cel_zamowienia: string;
    uslugi_dodatkowe: string[];
    ilosc_dodatkowych: number;
  };
  rodzaj_opakowania: string;
  ilosc: string;
  waga: string;
  dlugosc: string;
  szerokosc: string;
  wysokosc: string;
  rozmiar: string;
  klient: {
    nazwa: string;
    nip: string;
    telefon: string;
    email: string;
    info_dodatkowe: string;
  };
};

const mobileMenu: CollapseFaqArrayProps[] = [
  {
    key: 100,
    question: `${titleInfo1}`,
    answer: <HowItWorks />,
    content: "100bh-content",
    header: "100bh-header",
  },
  {
    key: 200,
    question: `${titleInfo2}`,
    answer: <TypesOfOffers />,
    content: "200bh-content",
    header: "200bh-header",
  },
];
export const OfferFormSummary = () => {
  useEffect(() => {
    if (!SessionService.isOrderSet()) {
      navigate(url.homePage);
    }
  }, []);
  const user = SessionService.getUser();
  const navigate = useNavigate();
  const isLoged = user && user.token_dostepu !== null ? true : false;

  const data: orderFormData = SessionService.getOrder();

  const startTime: string = new Date(
    data?.termin_rozpoczecia
  ).toLocaleDateString("pl-PL", { timeZone: "Europe/Warsaw" });
  const endTime = new Date(data?.termin_zakonczenia).toLocaleDateString(
    "pl-PL",
    { timeZone: "Europe/Warsaw" }
  );

  const typeOfStorage: string =
    data?.rodzaj_skladowania === "Wysokie" ||
    data?.rodzaj_skladowania === "Płaskie"
      ? `${data?.rodzaj_skladowania} składowanie`
      : data?.rodzaj_skladowania;

  let additionalServices: string = "";
  additionalServices += data?.uslugi_zamowione.uslugi_dodatkowe.map(
    (item) => ` ${item}`
  );

  const customerDataItems: PropertyItem[] = [
    {
      propertyName: "Nazwa firmy",
      propertyValue: data?.klient.nazwa,
    },
    {
      propertyName: "NIP",
      propertyValue: data?.klient.nip,
    },
    {
      propertyName: "Telefon",
      propertyValue: data?.klient.telefon,
    },
    {
      propertyName: "E-mail:",
      propertyValue: data?.klient.email,
    },
  ];
  const listSummary: PropertyItem[] = [
    {
      propertyName: "Lokalizacja:",
      propertyValue: `${data?.miasto}, ${data?.wojewodztwo}, ${data?.kraj}`,
    },
    {
      propertyName: "Na okres:",
      propertyValue: `od ${startTime} do ${endTime}`,
    },
    {
      propertyName: "Usługa:",
      propertyValue: data?.uslugi_zamowione.cel_zamowienia,
    },
    {
      propertyName: "Usługi dodatkowe:",
      propertyValue: additionalServices,
    },
    {
      propertyName: "Liczba usług dodatkowych:",
      propertyValue:
        additionalServices !== ""
          ? data?.uslugi_zamowione.ilosc_dodatkowych.toString()
          : "-",
    },
    {
      propertyName: "",
      propertyValue: data?.opis_uslugi,
    },
    {
      propertyName: "Miejsce:",
      propertyValue: data?.miejsce,
    },
    {
      propertyName: "Rodzaj składowania:",
      propertyValue: typeOfStorage,
    },
    {
      propertyName: "Warunki temperaturowe:",
      propertyValue: data?.warunek_temperaturowy,
    },
    {
      propertyName: "Rodzaj magazynu",
      propertyValue: "Standardowy",
    },
    {
      propertyName: "Rodzaj towaru",
      propertyValue: data?.rodzaj_towaru,
    },
    {
      propertyName: "",
      propertyValue: data?.opis_towaru,
    },
    {
      propertyName: "Specjalny sprzęt:",
      propertyValue: data?.specjalny_sprzet ? "Tak" : "Nie",
    },
    {
      propertyName: "",
      propertyValue: data?.specjalny_sprzet ? data?.specjalny_sprzet : "",
    },
  ];

  const listSpaceSummary: PropertySummaryItem[] = [
    {
      paleteName: `${data?.rodzaj_opakowania}`,
      paleteSize_MMxMMxMM: `${data?.dlugosc} mm x ${data?.szerokosc} mm x ${data?.wysokosc} mm`,
      paleteWight_Kg: `${Number(data?.waga) / Number(data?.ilosc)} kg/szt.`,
      order: {
        number: data?.ilosc,
        area: data?.rozmiar,
        weight: data?.waga, //Przyjete, że waga zawsze tutaj przychodzi w t
      },
    },
  ];
  return (
    <PageContainer>
      <PageNavBar>
        <Section1>
          <GoBackButton
            description={"Wróć do edycji danych"}
            goToUrl={`${url.offerForm}`}
          />
        </Section1>
        <Section2>
          <Title>{title}</Title>
        </Section2>
        <Section3 />
      </PageNavBar>
      <PCSumary>
        <PageContent>
          <Section1>
            <LeftGrayPage>
              <Block>
                <TitleInfo>{titleInfo1}</TitleInfo>
                <HowItWorks />
              </Block>
              <Block>
                <TitleInfo>{titleInfo2}</TitleInfo>
                <TypesOfOffers />
              </Block>
            </LeftGrayPage>
          </Section1>
          <Section2>
            <WhitePage>
              <Summary data={listSummary} />
              <Divider
                sx={{
                  borderColor: `${theme.colors.gray03_border2}`,
                  paddingTop: "24px",
                  marginBottom: "32px",
                }}
              />
              <Quantum data={listSpaceSummary} />
            </WhitePage>
          </Section2>
          <Section3>
            <RightGrayPage>
              {isLoged ? <></> : <CustomerData data={customerDataItems} />}
              <AdditionalRemarks data={data?.klient.info_dodatkowe} />
              {data ? <SubmitAnInquiryButton /> : null}
            </RightGrayPage>
          </Section3>
        </PageContent>
      </PCSumary>

      <MobileSumary>
        <CollapseInfo questionList={mobileMenu} />
        <WhitePage>
          <Summary data={listSummary} />
          <Divider
            sx={{
              borderColor: `${theme.colors.gray03_border2}`,
              paddingTop: "24px",
              marginBottom: "32px",
            }}
          />
          <Quantum data={listSpaceSummary} />
        </WhitePage>
        <AdditionalInfoWraper>
          {isLoged ? (
            <></>
          ) : (
            <Column isLoged={isLoged}>
              <CustomerData data={customerDataItems} />
            </Column>
          )}

          <Column isLoged={isLoged}>
            <AdditionalRemarks data={data?.klient.info_dodatkowe} />
          </Column>
        </AdditionalInfoWraper>
        <ActionWraper>
          <GoBackButton
            description={"Wróć do edycji danych"}
            goToUrl={`${url.offerForm}`}
          />
          {data ? <SubmitAnInquiryButton /> : null}
        </ActionWraper>
      </MobileSumary>
    </PageContainer>
  );
};
const ActionWraper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  @media (max-width: 470px) {
    flex-direction: column;
  }
`;
const MobileSumary = styled.div`
  display: block;
  @media (min-width: 1080px) {
    display: none;
  }
`;
const PCSumary = styled.div`
  display: none;
  @media (min-width: 1080px) {
    display: block;
  }
`;
const AdditionalInfoWraper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;

  @media (max-width: 600px) {
    flex-direction: column;
    padding-left: 10px;
  }
`;

const Column = styled.div<{
  isLoged: boolean;
}>`
  ${(props: any) => (props.isLoged ? "width: 100%" : "width: 50%")};
  //width:50%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;
const PageContainer = styled.div`
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  @media (min-width: 1080px) {
    padding: 20px 0px;
  }
`;
const TitleInfo = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.big};
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.black_primaryText};
  padding-bottom: 23px;
`;
const Block = styled.div`
  margin-bottom: 83px;
`;

const PageNavBar = styled.div`
  padding-bottom: 28px;
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 1080px) {
    padding: 20px 0px;
    flex-direction: row;
  }
`;
const Section1 = styled.div`
  width: 20%;
  padding-right: 30px;

  & button {
    display: none;
    padding-right: 0px;
  }

  @media (min-width: 1080px) {
    & button {
      display: flex;
    }
  }
`;
const Section2 = styled.div`
  width: 60%;
`;
const Section3 = styled.div`
  width: 20%;
  padding-left: 30px;
`;
const Title = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.big};
  font-size: 24px;
  line-height: 32px;
  color: ${theme.colors.black_primaryText};
`;
const PageContent = styled.div`
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-items: stretch;
`;
const WhitePage = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  @media (min-width: 1080px) {
    padding: 32px;
  }
`;
const LeftGrayPage = styled.div`
  padding-top: 32px;
  padding-right: 10px;
`;
const RightGrayPage = styled.div`
  padding-left: 10px;
  padding-top: 32px;
`;
